import React, { useState } from "react";
import BaseLayout from "../../layout/BaseLayout";
import { useParams } from "react-router-dom";
import { Tab, Tabs } from "@mui/material";
import PremierTrismestre from "./semestre/PremierTrismestre";
import DeuxiemeTrismestre from "./semestre/DeuxiemeTrimestre";
import TroisiemeTrismestre from "./semestre/TroisiemeTrismestre";
import BilanAnnuel from "./bilan-annuel/BilanAnnuel";

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`
  };
}

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <div>{children}</div>}
    </div>
  );
}

const Admission = () => {
  let { animateurId } = useParams();
  const [animateurSelected, setAnimateurSelected] = useState(null);
  const [valueTab, setValueTab] = useState(0);

  const handleChangeTab = (event, newValue) => {
    setValueTab(newValue);
  };

  return (
    <BaseLayout>
      <div className="w-full h-full">
        <div className="w-full">
          <h1 className="text-2xl md:text-3xl font-extrabold">Admissions</h1>
          <p className="mt-2 text-gray-500 font-medium text-sm sm:text-base md:text-lg">
            Listes des notes par trismetre pour cette année
          </p>
        </div>

        <div className="mt-5 border-b">
          <Tabs
            value={valueTab}
            onChange={handleChangeTab}
            variant="scrollable"
            textColor="black"
            scrollButtons="auto"
            aria-label="basic tabs example"
          >
            <Tab
              label="1er trimestre"
              {...a11yProps(0)}
              sx={{
                textTransform: "capitalize",
                fontSize: 14,
                fontWeight: 700
              }}
            />
            <Tab
              label="2ème trimestre"
              {...a11yProps(1)}
              sx={{
                textTransform: "capitalize",
                fontSize: 14,
                fontWeight: 700
              }}
            />
            <Tab
              label="3ème trimestre"
              {...a11yProps(2)}
              sx={{
                textTransform: "capitalize",
                fontSize: 14,
                fontWeight: 700
              }}
            />
            <Tab
              label="Bilan Annuel"
              {...a11yProps(3)}
              sx={{
                textTransform: "capitalize",
                fontSize: 14,
                fontWeight: 700
              }}
            />
          </Tabs>
        </div>

        <div className="mt-8">
          <CustomTabPanel value={valueTab} index={0}>
            <PremierTrismestre />
          </CustomTabPanel>
          <CustomTabPanel value={valueTab} index={1}>
            <DeuxiemeTrismestre />
          </CustomTabPanel>
          <CustomTabPanel value={valueTab} index={2}>
            <TroisiemeTrismestre />
          </CustomTabPanel>
          <CustomTabPanel value={valueTab} index={3}>
            <BilanAnnuel />
          </CustomTabPanel>
        </div>
      </div>
    </BaseLayout>
  );
};

export default Admission;
